module.exports = __webpack_public_path__ + "static/board-04-d72528fa927597eddcb082584d049329.jpg";